<template>
  <div class="million-read-count-down-block">
    <div v-if="prefix !== ''"
         class="million-read-count-down-block-prefix"
         v-html="prefix"
    ></div>
    <div class="million-read-count-down-block-timer">
      <!-- eslint-disable max-len -->
      <span>{{ hours }}</span>:<span>{{ timerData.minutes }}</span>:<span>{{ timerData.seconds }}</span>:<span>{{ timerData.mSeconds }}</span>
    </div>
    <div v-if="suffix !== ''"
         class="million-read-count-down-block-suffix"
         v-html="suffix"
    ></div>
  </div>
</template>

<script>
  import CountDown from '@/utils/count-down';

  export default {
    name: 'MillionReadCountDownBlock',
    props: {
      prefix: {
        type: String,
        default: '',
      },
      endTime: {
        type: Number,
        required: true,
      },
      suffix: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        timerData: {
          days: '00',
          hours: '00',
          minutes: '00',
          seconds: '00',
          mSeconds: '0',
        },
      };
    },
    computed: {
      startTime() {
        return new Date().getTime();
      },
      hours() {
        return parseInt(this.timerData.days, 10) * 24 + parseInt(this.timerData.hours, 10);
      },
    },
    methods: {
      initCountDown() {
        new CountDown({
          delay: 100,
          startTime: this.startTime,
          endTime: this.endTime,
          render: (data) => {
            this.timerData = data;
          },
          end: () => {
            this.$emit('count-down-end');
          },
        });
      },
    },
    created() {
      this.initCountDown();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .million-read-count-down-block {
    display: flex;
    align-items: center;
    color: @color-white;
    font-size: 21px;
    font-weight: @font-weight-strong;
    line-height: 1;
    &-timer {
      width: 136px;
      display: flex;
      justify-content: center;
      color: #ffe535;
    }
    &-prefix,
    &-suffix {
      /deep/ .highlight {
        color: #ffe535;
      }
    }
  }

</style>
